export default __webpack_public_path__ + "2025 Detecting zero-point fluctuations with stochastic Brownian oscillators.pdf";